<template>
	<div class="table__pagination" v-if="currentLength > 0">
		<span>{{ currentLength }} von {{ totalMaxVal }} </span>
		<TheButton @buttonclick="$emit('loadNextPage')" v-if="currentLength < totalMaxVal">mehr laden</TheButton>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TheButton from '../TheButton.vue';

export default defineComponent({
	name: 'TablePagination',
	data() {
		return {};
	},
	props: {
		currentLength: {
			type: Number,
			required: true,
		},
		totalMaxVal: {
			type: Number,
			required: true,
		},
	},
	emits: ['loadNextPage'],
	setup() {},
	components: {
		TheButton,
	},
	mounted() {},
});
</script>

<style lang="scss">
.table__pagination {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 0.9rem;
	padding: 1.5rem 0;

	button {
		margin-top: 1.5rem;
		width: auto;
	}
}
</style>
